import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_PRODUCTS_RECEIVESETS_SUCCESS,
    GET_PRODUCTS_RECEIVESETS_FAILURE,
} from 'src/pages/receiveSets/redux/actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

import { convertObjectToQueryParams } from 'src/utils/util';

export default function* searchProducts() {
    let url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productList?`;

    const query = yield select(
        (state) => state.receiveSetsProductsSearchReducer.queryParams
    );
    const queryParams = { ...query };
    const token = queryParams.cancelSearchToken;
    delete queryParams.cancelSearchToken;
    if (queryParams)
        url = `${url}${convertObjectToQueryParams(queryParams, true)}`;

    try {
        const result = yield axios
            .get(url, { cancelToken: token })
            .then((response) => response.data);
        yield put({
            type: GET_PRODUCTS_RECEIVESETS_SUCCESS,
            products: result.productsList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            totalRecordsCount: result.productsTotalCount,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: queryParams
        });
        yield put({
            type: GET_PRODUCTS_RECEIVESETS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
